<div class="layout-container" *ngIf="this.layoutHelper">
  <div #timeBlocksContainer class="time-blocks-container">
    <svg class="time-blocks"
         [style.width]="this.layoutHelper.svgWidth"
         [style.height]="this.layoutHelper.svgHeight">
      <defs>
        <symbol id="operator-note-needed-icon" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0V0z" fill="none" />
          <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" />
        </symbol>
        <symbol id="operator-note-present-icon" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M5 5 h14 v10 H5z" fill="white" />
          <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z" />
        </symbol>
        <pattern id="diagonalHatch" patternUnits="userSpaceOnUse" width="4" height="4">
          <path d="M-1,1 l2,-2  M0,4 l4,-4  M3,5 l2,-2" class="diagonal-hatch" />
        </pattern>
        <pattern id="overdueDiagonalHatch" patternUnits="userSpaceOnUse" width="4" height="4">
          <path d="M-1,3 L3,-1  M1,5 L5,1" class="overdue-diagonal-hatch" />
        </pattern>
        <linearGradient id="activeFill">
          <stop class="active-fill-stop" />
        </linearGradient>
        <linearGradient id="inactiveFill">
          <stop class="inactive-fill-stop" />
        </linearGradient>
        <linearGradient id="activeIndefiniteFill">
          <stop class="active-fill-stop" offset="0%" />
          <stop class="active-fill-stop" offset="90%" />
          <stop class="active-indefinite-fill-stop" offset="100%" />
        </linearGradient>
        <linearGradient id="inactiveIndefiniteFill">
          <stop class="inactive-fill-stop" offset="0%" />
          <stop class="inactive-fill-stop" offset="90%" />
          <stop class="inactive-indefinite-fill-stop" offset="100%" />
        </linearGradient>

        <linearGradient id="activeStroke">
          <stop class="active-stroke-stop" />
        </linearGradient>
        <linearGradient id="inactiveStroke">
          <stop class="inactive-stroke-stop" />
        </linearGradient>
        <linearGradient id="activeIndefiniteStroke">
          <stop class="active-stroke-stop" offset="0%" />
          <stop class="active-stroke-stop" offset="90%" />
          <stop class="active-indefinite-stroke-stop" offset="100%" />
        </linearGradient>
        <linearGradient id="inactiveIndefiniteStroke">
          <stop class="inactive-stroke-stop" offset="0%" />
          <stop class="inactive-stroke-stop" offset="90%" />
          <stop class="inactive-indefinite-stroke-stop" offset="100%" />
        </linearGradient>
      </defs>
      <!-- Draw division lines and ruler -->
      <g>
        <!-- Iterate time-axis divisions -->
        <g *ngFor="let item of this.timeDivisions; let i = index">
          <!-- Time division lines -->
          <line [attr.x1]="this.layoutHelper.getTimeDivisionLineXPosition(i)"
                [attr.y1]="this.layoutHelper.top"
                [attr.x2]="this.layoutHelper.getTimeDivisionLineXPosition(i)"
                [attr.y2]="this.layoutHelper.bottom"
                stroke-width="0.5"
                stroke-dasharray="3,3"
                stroke="#00000045" />
        </g>
      </g>

      <!-- Iterate rows -->
      <g *ngFor="let item of this.tasks; let i = index">
        <!-- Row bottom border -->
        <line [attr.x1]="this.layoutHelper.left"
              [attr.y1]="this.layoutHelper.getRowBottomYPosition(i)"
              [attr.x2]="this.layoutHelper.right"
              [attr.y2]="this.layoutHelper.getRowBottomYPosition(i)"
              stroke-width="1"
              stroke="#dadada" />

        <!-- TimeBlocks -->
        <g *ngFor="let block of item.timeBlocks">
          <rect class="time-block"
                [attr.id]="block.startTaskEventId"
                rx="3"
                [class.active]="block.isActive"
                [class.inactive]="!block.isActive"
                [class.indefinite]="!block.endTime"
                [attr.x]="this.layoutHelper.getTimeBlockXPosition(block.startOffsetInMinutes)"
                [attr.y]="this.layoutHelper.getTimeBlockYPosition(i)"
                [attr.width]="this.layoutHelper.getTimeBlockWidth(block)"
                [attr.height]="this.layoutHelper.timeBlockHeight"
                [attr.stroke-width]="this.layoutHelper.timeBlockStrokeWidth"
                [attr.fill]="this.getDefinitionUrl(this.layoutHelper.getFillName(block))"
                [attr.stroke]="this.getDefinitionUrl(this.layoutHelper.getStrokeDefinition(block))"
                (click)="this.selectTimeBlock(block , $event)" />


          <!-- Operator Note indicator -->
          <use *ngIf="this.needsNote(block)"
               class="indicator"
               fill="red"
               [attr.x]="this.layoutHelper.getIconXPosition(block)"
               [attr.y]="this.layoutHelper.getIconYPosition(i)"
               href="#operator-note-needed-icon"
               [attr.width]="this.layoutHelper.iconSize"
               [attr.height]="this.layoutHelper.iconSize"
               [attr.clip-path]="this.layoutHelper.getIconClipPath(block)" />

          <use *ngIf="this.hasNote(block)"
               class="indicator"
               fill="black"
               [attr.x]="this.layoutHelper.getIconXPosition(block)"
               [attr.y]="this.layoutHelper.getIconYPosition(i)"
               href="#operator-note-present-icon"
               [attr.width]="this.layoutHelper.iconSize"
               [attr.height]="this.layoutHelper.iconSize"
               [attr.clip-path]="this.layoutHelper.getIconClipPath(block)" />


          <!-- TimeBlock isOverdue overlay -->
          <rect *ngIf="this.isOverdue(item, block)"
                class="overdue"
                rx="3"
                [attr.x]="this.layoutHelper.getOverdueOverlayXPosition(block, item.standardEndOffsetInMinutes!)"
                [attr.y]="this.layoutHelper.getOverdueOverlayYPosition(i)"
                [attr.width]="this.layoutHelper.getOverdueOverlayWidth(block, item.standardEndOffsetInMinutes!)"
                [attr.height]="this.layoutHelper.OverdueOverlayHeight"
                [attr.stroke-width]="this.layoutHelper.timeBlockStrokeWidth * 2"
                [attr.fill]="this.getDefinitionUrl('overdueDiagonalHatch')" />

          <!-- TimeBlock selection overlay -->
          <rect *ngIf="this.isSelected(block)"
                class="selection"
                rx="3"
                [attr.x]="this.layoutHelper.getSelectionOverlayXPosition(block.startOffsetInMinutes)"
                [attr.y]="this.layoutHelper.getSelectionOverlayYPosition(i)"
                [attr.width]="this.layoutHelper.getSelectionOverlayWidth(block)"
                [attr.height]="this.layoutHelper.SelectionOverlayHeight"
                [attr.stroke-width]="this.layoutHelper.selectionStrokeWidth"
                [attr.fill]="this.getDefinitionUrl('diagonalHatch')" />
        </g>

        <!-- Standard end time marker -->
        <line *ngIf="!item.isOngoing && item.standardEndOffsetInMinutes"
              [attr.x1]="this.layoutHelper.getStandardEndTimeMarkerXPosition(item.standardEndOffsetInMinutes!)"
              [attr.y1]="this.layoutHelper.getRowBottomYPosition(i-1)"
              [attr.x2]="this.layoutHelper.getStandardEndTimeMarkerXPosition(item.standardEndOffsetInMinutes!)"
              [attr.y2]="this.layoutHelper.getRowBottomYPosition(i)"
              stroke-width="2"
              stroke-dasharray="6,4"
              [attr.stroke]="item.isOverdue ? '#FF0000' : '#00CC00'" />
      </g>

      <!-- Current time marker -->
      <line *ngIf="this.layoutHelper.getCurrentTimeMarkerXPosition()"
            [attr.x1]="this.layoutHelper.getCurrentTimeMarkerXPosition()"
            [attr.y1]="this.layoutHelper.top"
            [attr.x2]="this.layoutHelper.getCurrentTimeMarkerXPosition()"
            [attr.y2]="this.layoutHelper.bottom"
            stroke-width="1.5"
            stroke-dasharray="3,3"
            stroke="#000000AA" />
    </svg>
  </div>
</div>